// src/frontend/data/books/DarkForest/data/cap13.js

const CAP13 = {
  id: 13,
  title: "Billetera caliente (Hot Wallet)",
  sections: [
    {
      heading: "¿Qué es una hot wallet?",
      text: [
        "Una hot wallet es una billetera que permanece conectada a Internet o se usa en un dispositivo que está en línea la mayor parte del tiempo.",
        "En comparación con una cold wallet, una hot wallet hereda prácticamente todos los riesgos de uso (errores al firmar, direcciones equivocadas, approvals peligrosos, etc.) y, además, añade un riesgo crítico: el robo directo de la frase secreta (seed phrase) o de la clave privada.",
        "Por esta razón, una hot wallet debe considerarse como una billetera de uso cotidiano, no como el lugar definitivo para guardar todo tu patrimonio cripto."
      ]
    },
    {
      heading: "Riesgos adicionales de una hot wallet",
      text: [
        "Además de los riesgos normales de operación, en una hot wallet hay que preocuparse por la seguridad del entorno donde se ejecuta:",
       "🔹 Presencia de virus o malware en el sistema operativo.",
       "🔹 Plugins o extensiones maliciosas en el navegador.",
       "🔹 Aplicaciones que registran teclas o capturas de pantalla.",
        "Si el entorno está comprometido, un atacante puede llegar a leer directamente tu frase secreta, clave privada o archivos de respaldo y vaciar la billetera sin que te des cuenta."
      ]
    },
    {
      heading: "Interacción con DApps: cómo se usa una hot wallet",
      text: [
        "Para usar DeFi, NFT, GameFi u otras DApps de Web3, normalmente tienes dos caminos:",
        "1. Acceder a la DApp desde el navegador integrado de la propia billetera.",
        "2. Usar la billetera como extensión del navegador (por ejemplo, MetaMask) o conectarla a la DApp a través de WalletConnect.",
        "En este libro, cuando hablamos de DApps nos referimos, por defecto, a proyectos de contratos inteligentes que corren sobre la blockchain de Ethereum (o redes compatibles EVM)."
      ]
    },
    {
      heading: "¿Estas interacciones roban mi frase secreta?",
      text: [
        "En condiciones normales, la simple interacción con una DApp no debería provocar el robo de tu frase secreta. La billetera firma transacciones, pero la seed phrase nunca se envía a la página.",
        "Sin embargo, existe un riesgo teórico: una cartera mal diseñada podría exponer la frase secreta a JavaScript malicioso que se ejecute en la página de la DApp.",
        "Este tipo de fallo es muy grave y se considera un error de nivel muy bajo; por eso, los monederos conocidos y auditados hacen grandes esfuerzos para evitarlo."
      ]
    },
    {
      heading: "La preocupación principal: las actualizaciones",
      text: [
        "Más allá de los errores de diseño obvios, mi mayor preocupación (y debería ser la tuya también) es la siguiente:",
        "“¿Cómo puedo estar seguro de que en la próxima actualización de la billetera no se introducirá código malicioso o un backdoor?”",
        "Tal vez hayas auditado o revisado la versión actual y la consideres segura, pero eso no garantiza que la siguiente versión también lo sea.",
        "Ni tú ni tu equipo de seguridad pueden revisar cada actualización de cada wallet a fondo; eso abre la puerta a ataques que se disparan tras una actualización aparentemente inocente."
      ]
    },
    {
      heading: "Ejemplos reales de incidentes",
      text: [
        "Ya han existido incidentes en los que se robaron fondos debido a código malicioso o puertas traseras en billeteras populares, como en los casos de CoPay, AToken y otros.",
        "En estos escenarios, la billetera se comporta bien por un tiempo, hasta que una versión concreta introduce la trampa.",
        "Si quieres profundizar, puedes buscar estos incidentes por tu cuenta y estudiar cómo ocurrieron y qué vulnerabilidades se aprovecharon."
      ]
    },
    {
      heading: "Formas típicas de hacer el mal en una hot wallet",
      text: [
        "Entre las técnicas más peligrosas asociadas a billeteras calientes se encuentran:",
       "🔹 Mientras la wallet está abierta, el código malicioso empaqueta y envía tu frase secreta o clave privada a un servidor controlado por el atacante.",
       "🔹 Cuando inicias una transferencia, el backend de la billetera reemplaza silenciosamente la dirección de destino o incluso el monto, de modo que firmas una transacción diferente a la que ves.",
       "🔹 Se manipula la aleatoriedad usada para generar frases o claves privadas, produciendo seeds débiles o parcialmente predecibles, que luego pueden descifrarse con menos esfuerzo."
      ]
    },
    {
      heading: "Regla práctica para billeteras con activos importantes",
      text: [
        "La seguridad es, en gran medida, una cuestión de conocimiento y de ignorancia: puedes pasar por alto detalles pequeños que tienen consecuencias enormes.",
        "Por eso, cuando una billetera caliente guarda activos importantes, mi regla de seguridad es muy simple:",
        "Si la versión actual funciona bien y cumple con lo que necesitas, evita actualizarla a la ligera.",
        "En otras palabras: “si está bien y te basta, no la actualices por impulso”. Antes de aceptar una actualización, espera, investiga, revisa opiniones y evalúa si realmente la necesitas."
      ]
    },
    {
      heading: "Conclusión: uso responsable de la hot wallet",
      text: [
        "La hot wallet es tu herramienta diaria para firmar, mover tokens e interactuar con DApps. Es necesaria, pero no debe ser tu única línea de defensa.",
        "Úsala con montos moderados, mantén la mayor parte de tu patrimonio en esquemas más fríos (hardware wallets y estrategias de respaldo robustas) y sé conservadora/o con las actualizaciones.",
        "Recordar esta estrategia sencilla puede ahorrarte muchos dolores de cabeza en el futuro."
      ]
    }
  ]
};

export default CAP13;
